import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class OutsourcedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            reportUrl:'/api/v1/portal/portal-admin/outsourced-jobs-report/',
            totaloutsourcedJobs:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Inter Company Jobs Report',
            isDownloading:false,
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleTotalJobsRaisedByUserReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.reportUrl+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
          }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              //console.log(response.users);  
              this.setState({
                totaloutsourcedJobs: response,
                isLoading: false
              })
            });
        }).catch(err=>{
            alert('sorry something went wrong.'+err);
        });
    }

    downloadableCsvData(filename,text){
        this.setState({isDownloading: true});
        let filenamed = filename+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "JOB REF,REG/VIN,CUSTOMER,SUBCONTRACTED TO,STATUS,DRIVER COMPLETED DATE,INVOICE NUMBER,JOB PRICE\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
    }
    render() {
        let totaloutsourcedJobs = [];
        const {selectedCustomers} = this.state;
        let downloadCsvData = [];
        let finalTotal = 0;
        let totalGeminiJobPrice = 0.00;
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.gemini && this.state.totaloutsourcedJobs.gemini.length > 0){
                this.state.totaloutsourcedJobs.gemini.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ ((job.vehicle!=undefined)&&(job.vehicle.registration_number!=undefined))?job.vehicle.registration_number:''}</td> 
                            <td>{ ((job.customer!=undefined)&&(job.customer.name!=undefined))?job.customer.name:''}</td>
                            <td>{ ((job.subcontracted_to_company!=undefined)&&(job.subcontracted_to_company.short_name!=undefined))?job.subcontracted_to_company.short_name:''}</td>
                            <td>{ (job.status!=undefined)?job.status:''}</td>
                            <td>{((job.driver_completed_at!=undefined) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>
                            <td>{ (job.invoice_number!=undefined)?job.invoice_number:''}</td>       
                            <td>&pound;{ (job.job_price!=undefined)?job.job_price:''}</td>
                        </tr>
                    );
                    totalGeminiJobPrice = parseFloat(totalGeminiJobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            ((job.vehicle!=undefined)&&(job.vehicle.registration_number!=undefined))?job.vehicle.registration_number:''+','+
                                            ((job.customer!=undefined)&&(job.customer.name!=undefined))?job.customer.name:''+','+
                                            ((job.subcontracted_to_company!=undefined)&&(job.subcontracted_to_company.short_name!=undefined))?job.subcontracted_to_company.short_name:''+','+
                                            (job.status!=undefined)?job.status:''+','+
                                            ((job.driver_completed_at!=undefined) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            (job.invoice_number!=undefined)?job.invoice_number:''+','+
                                            (job.job_price!=undefined)?job.job_price:''+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalGeminiJobPrice);
                totaloutsourcedJobs.push(
                    <tr key="geminitotal" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF Gemini</strong></td>
                        <td><strong>&pound;{totalGeminiJobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
            }
            downloadCsvData = downloadCsvData +
                                            '\nTOTAL OF Gemini'+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            totalGeminiJobPrice.toFixed(2)+"\n";
            let totalgdnwJobPrice = 0.00;
            if(this.state.totaloutsourcedJobs && this.state.totaloutsourcedJobs.gdnw && this.state.totaloutsourcedJobs.gdnw.length > 0){
                this.state.totaloutsourcedJobs.gdnw.map((job, index) => {
                    let joburl = "/jobs/view/"+job.id;
                    totaloutsourcedJobs.push(
                        <tr key={index+'-'+job.id}>
                            <td className="job-ref-font16"><a href={joburl}>{job.id}</a></td>
                            <td>{ ((job.vehicle!=undefined)&&(job.vehicle.registration_number!=undefined))?job.vehicle.registration_number:''}</td> 
                            <td>{ ((job.customer!=undefined)&&(job.customer.name!=undefined))?job.customer.name:''}</td>
                            <td>{ ((job.subcontracted_to_company!=undefined)&&(job.subcontracted_to_company.short_name!=undefined))?job.subcontracted_to_company.short_name:''}</td>
                            <td>{ (job.status!=undefined)?job.status:''}</td>
                            <td>{((job.driver_completed_at!=undefined) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")}</td>
                            <td>{ (job.invoice_number!=undefined)?job.invoice_number:''}</td>       
                            <td>&pound;{ (job.job_price!=undefined)?job.job_price:''}</td>
                        </tr>
                    );
                    totalgdnwJobPrice = parseFloat(totalgdnwJobPrice) + parseFloat(job.job_price);
                    downloadCsvData = downloadCsvData +
                                            job.id+','+
                                            ((job.vehicle!=undefined)&&(job.vehicle.registration_number!=undefined))?job.vehicle.registration_number:''+','+
                                            ((job.customer!=undefined)&&(job.customer.name!=undefined))?job.customer.name:''+','+
                                            ((job.subcontracted_to_company!=undefined)&&(job.subcontracted_to_company.short_name!=undefined))?job.subcontracted_to_company.short_name:''+','+
                                            (job.status!=undefined)?job.status:''+','+
                                            ((job.driver_completed_at!=undefined) ? moment(job.driver_completed_at).format("DD/MM/YY") : "")+','+
                                            (job.invoice_number!=undefined)?job.invoice_number:''+','+
                                            (job.job_price!=undefined)?job.job_price:''+"\n";
                });
                finalTotal = parseFloat(finalTotal) + parseFloat(totalgdnwJobPrice);
                totaloutsourcedJobs.push(
                    <tr key="gdnwtotal" className="job-ref-font16">
                        <td  colSpan="7"><strong>TOTAL OF Gemini Drivers North West</strong></td>
                        <td><strong>&pound;{totalgdnwJobPrice.toFixed(2)}</strong></td>
                    </tr>
                );
            }
            downloadCsvData = downloadCsvData +
                                            'TOTAL OF Gemini Drivers North West'+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            ''+','+
                                            totalgdnwJobPrice.toFixed(2)+"\n";
            totaloutsourcedJobs.push(
                <tr key="finaltotal" className="job-ref-font16">
                    <td colSpan="7"><strong>TOTAL OF ALL</strong></td>
                    <td><strong>&pound;{finalTotal.toFixed(2)}</strong></td>
                </tr>
            );
            downloadCsvData = downloadCsvData +
                                        'TOTAL OF ALL'+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        finalTotal.toFixed(2)+"\n";
            
        
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2> Inter Company Jobs Report</h2>
                    <br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select From Date:
                    </div>
                    <div className="col-md-2">
                       Select To Date:
                    </div>
                    <div className="col-md-2">
                        Select Customer:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <div>
                            <StatefulMultiSelect
                                options={this.state.customers}
                                selected={selectedCustomers}
                                onSelectedChanged={this.handleCustomerSelection}
                                    overrideStrings={{
                                        selectSomeItems: "Select Customers...",
                                        allItemsAreSelected: "All Customers are Selected",
                                        selectAll: "Select All",
                                        search: "Search Customer",
                                    }}
                                />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsRaisedByUserReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Outsourced Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvData(this.state.filename,downloadCsvData)}}>
                                <i className="fa fa-download"></i> Download Outsourced Jobs Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-md-6">
                        <label className="alert alert-primary"><b>{this.state.totaloutsourcedJobs.length} jobs found..</b></label>
                    </div>             
                </div> */}
                <div className="row">
                    <div className="col-md-10 col-sm-10">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl font-normal">
                                <thead className="sticky-top-without-zindex bg-light">
                                   <tr>
                                        <th>Job Ref</th>
                                        <th>REG/VIN</th>
                                        <th>CUSTOMER</th>
                                        <th>Subcontracted To</th>
                                        <th>Status</th>
                                        <th>Driver Completed Date</th>
                                        <th>Invoice Number</th>
                                        <th>Job Price</th>
                                   </tr>
                                </thead> 
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="8"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totaloutsourcedJobs}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-outsourced-jobs-report')) {
    ReactDOM.render(
        <OutsourcedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-outsourced-jobs-report')
    );
}
